/**
 * @description: 报销系统入口页
 * @author: lyr
*/
<template>
    <div class="report-system-index">
        <div class="iframe-container">
            <iframe
                id="myIframe"
                :src="iframeUrl"
                frameborder="1"
                width="100%"
                height="1000px"
                allowfullscreen
                @load="iframeLoaded"
            ></iframe>
        </div>
        <div class="bill-detail" v-show="showBillDetail">
            <billDetail ref="bill_detail" @backBdwPre="showBillDetail=false"></billDetail>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    import billDetail from '@/components/bill_detail.vue';
    export default {
        name: 'report-system-index',
        data() {
            return {
                layIndex: null,
                showBillDetail: false, // 显示账单详情
                iframeUrl: '',
                message: {
                    to: '',
                    params: {}
                },
                deposit_manage_menu: {}, // 寄存管理菜单
            }
        },
        components: {
            "billDetail": billDetail
        },
        computed: {
            fatherHost() {
                if(window.location.host.indexOf('localhost') < 0) {
                    return window.location.host
                }else {
                    return 'http://localhost:8080'
                }
            },
            iframeHost() {
                if(window.location.host.indexOf('localhost') < 0) {
                    return this.$store.state.report_base_url.split("/report/")[0]
                }else {
                    return 'http://localhost:3000'
                }
            },
            menunew() {
                return JSON.parse(this.$store.state.menunew)
            },
        },
        watch: {
            '$route': {
                handler: function(val, oldVal) {
                    if(!!val.params.business_day) {// business_day:寄存结转报表“期末详情”
                        this.message.params.business_day = val.params.business_day
                        this.message.params.goods_name = val.params.goods_name
                        this.message.params.shop_id = val.params.shop_id
                        this.sendMessageToIframe(this.message) // 给iframe发送消息
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            this.message = {
                to: this.$route.params.to,
                params: {
                    token: this.$store.state.report_token
                }
            }
            this.getPageMenu()
            this.layIndex = layer.load(0, {
                shade: [0.1, '#ececec']
            })
            if(window.location.host.indexOf('localhost') < 0) {
                this.iframeUrl = this.$store.state.report_base_url + 'web/report-system/dist/index.html#/'; // 报表系统首页
            }else {
                this.iframeUrl = this.iframeHost + '/#/'
            }

            // 第一次打开
            if(!!this.$route.params.business_day) { // business_day:寄存结转报表“期末详情”
                this.message.params.business_day = this.$route.params.business_day
                this.message.params.goods_name = this.$route.params.goods_name
                this.message.params.shop_id = this.$route.params.shop_id
            }

            //监听来自iframe的消息
            window.addEventListener('message', this.handleMessage)
        },
        methods: {
            // 当 iframe 加载完毕时调用
            iframeLoaded() {
                // 发送通知给 iframe
                this.sendMessageToIframe(this.message)
                layer.close(this.layIndex)
            },

            // 父页面发送消息给 iframe
            sendMessageToIframe(message) {
                const iframe = document.getElementById('myIframe'); 
                console.log("postMessage")
                iframe.contentWindow.postMessage(message, this.iframeHost); // '*'表示不限制域名，出于安全考虑应指定确切的源
            },

            // 处理来自iframe的消息
            handleMessage(event) {
                // 验证消息来源
                if (event.origin !== this.iframeHost) {
                    return;
                }

                // 处理接收到的消息
                console.log('Received message from iframe:', event.data);
                if(typeof event.data.bill_no !== 'undefined') { // 营销员工业绩报表点击“账单详情”
                    let bill_no = event.data.bill_no
                    this.showBillDetail = true
                    this.$refs.bill_detail.getBdwDetail(bill_no)
                }
                if(typeof event.data.deposit_id !== 'undefined') { // 寄存结存明细报表点击“寄存明细”
                    let deposit_id = event.data.deposit_id
                    let obj = {
                        name: 'deposit_manage',
                        params: {
                           deposit_id: deposit_id,
                        }
                    }
                    this.$emit("pageLink", this.deposit_manage_menu, obj)
                }
            },

             // 跳转菜单
            getPageMenu: function() {
                this.menunew.forEach(i => {
                    if(i.id == '543') { // 仓库管理
                        i.submenu.forEach(j => {
                            if(j.id == '689') { // 寄存管理
                               this.deposit_manage_menu = j
                            }
                        })
                    }
                })
            },

            // 在组件销毁时移除监听器
            destroyed() {
                window.removeEventListener('message', this.handleMessage);
            },
        }
    }
</script>
<style lang="less" scoped>
   .bill-detail {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        width: 100%;
        background: #fff;
        padding: 10px;
        min-height: 1000px;
   }
</style>